import Loader from '@/Helpers/Loader';
import Bus from '@/bus';

export const ResponseInterceptor = response => {
  Loader.done();
  window.offline = false;

  Bus.$emit('connection', true);

  return response;
};
